import { apiClient } from "@/lib/api/client";
import { User } from "@/types";
import { Appointment, CreateAppointmentData } from "@/types/appointment";

export const appointmentService = {
  async getAppointments(): Promise<Appointment[]> {
    const response = await apiClient.get("/appointments");
    return response.data.data;
  },
  
  async getUserAppointments(user_id: string): Promise<Appointment[]> {
    const response = await apiClient.get(`/appointments/user/${user_id}`)
    return response.data.data
  },

  async getDoctorAppointments(doctor_id: string): Promise<Appointment[]> {
    try {
      const response = await apiClient.get("/appointments", {
        params: {
          doctor_id: doctor_id,
        }
      });
      return response.data.data || [];
    } catch (error: any) {
      console.error('Error fetching doctor appointments:', error);
      return [];
    }
  },

  async rescheduleAppointment(
    appointmentId: number,
    data: {
      requestor: string;
      appointment_date: string;
      appointment_time: string;
      reason: string;
    }
  ): Promise<{ message: string; data: Appointment }> {
    try {
      const response = await apiClient.post(
        `/appointments/${appointmentId}/reschedule`,
        data
      );
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to reschedule appointment"
      );
    }
  },

  async createAppointment(
    data: CreateAppointmentData
  ): Promise<{ message: string; data: Appointment }> {
    try {
      const response = await apiClient.post("/appointments", data);
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to create appointment"
      );
    }
  },
  
  async getAppointment(id: string): Promise<Appointment> {
    const response = await apiClient.get(`/appointments/${id}`);
    return response.data.data;
  },
  
  async cancelAppointment(
    id: string | number,
    reason: string
  ): Promise<{ message: string; data: Appointment }> {
    try {
      const response = await apiClient.post(`/appointments/${id}/cancel`, {
        reason,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to cancel appointment"
      );
    }
  },
  
  async deleteAppointment(id: number): Promise<{ message: string }> {
    try {
      const response = await apiClient.delete(`/appointments/${id}`);
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to delete appointment"
      );
    }
  },
  
  async updateAppointment(
    id: string | number,
    data: any
  ): Promise<{ message: string; data: Appointment }> {
    try {
      const response = await apiClient.put(`/appointments/${id}`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to update appointment"
      );
    }
  },
};